"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextRate = exports.nextCron = void 0;
const common_1 = require("./common");
const findOnce = (parsed, from, iter = 0) => {
    if (iter > 10) {
        throw new Error("AwsCronParser : this shouldn't happen, but iter > 10");
    }
    iter += 1;
    from = getLatestDate(from, parsed.start);
    const cYear = from.getUTCFullYear(); // timezone === 'local' ? from.getFullYear() :
    const cMonth = from.getUTCMonth() + 1; // timezone === 'local' ? from.getMonth() + 1 :
    const cDayOfMonth = from.getUTCDate(); // timezone === 'local' ? from.getDate() :
    const cHour = from.getUTCHours(); // timezone === 'local' ? from.getHours() :
    const cMinute = from.getUTCMinutes(); // timezone === 'local' ? from.getMinutes() :
    const year = (0, common_1.arrayFindFirst)(parsed.years, (c) => c >= cYear);
    if (!year) {
        return null;
    }
    const month = (0, common_1.arrayFindFirst)(parsed.months, (c) => c >= (year === cYear ? cMonth : 1));
    iter > 5 && console.log("month", month, new Date(from), parsed);
    if (!month) {
        return findOnce(parsed, getDate(year + 1, 1), iter);
    }
    const isSameMonth = year === cYear && month === cMonth;
    let pDaysOfMonth = parsed.daysOfMonth;
    if (pDaysOfMonth.length === 0) {
        pDaysOfMonth = (0, common_1.getDaysOfMonthFromDaysOfWeek)(year, month, parsed.daysOfWeek);
    }
    else if (pDaysOfMonth[0] === 'L') {
        pDaysOfMonth = (0, common_1.getDaysOfMonthForL)(year, month, pDaysOfMonth[1]);
    }
    else if (pDaysOfMonth[0] === 'W') {
        pDaysOfMonth = (0, common_1.getDaysOfMonthForW)(year, month, pDaysOfMonth[1]);
    }
    const dayOfMonth = (0, common_1.arrayFindFirst)(pDaysOfMonth, (c) => c >= (isSameMonth ? cDayOfMonth : 1));
    iter > 5 && console.log("dayOfMonth", dayOfMonth, new Date(from));
    if (!dayOfMonth) {
        return findOnce(parsed, getDate(year, month + 1), iter);
    }
    const isSameDate = isSameMonth && dayOfMonth === cDayOfMonth;
    const hour = (0, common_1.arrayFindFirst)(parsed.hours, (c) => c >= (isSameDate ? cHour : 0));
    iter > 5 && console.log('hour', hour);
    if (typeof hour === 'undefined') {
        return findOnce(parsed, getDate(year, month, dayOfMonth + 1), iter);
    }
    const minute = (0, common_1.arrayFindFirst)(parsed.minutes, (c) => c >= (isSameDate && hour === cHour ? cMinute : 0));
    iter > 5 && console.log('minute', minute);
    if (typeof minute === 'undefined') {
        return findOnce(parsed, getDate(year, month, dayOfMonth, hour + 1, minute), iter);
    }
    iter > 5 && console.log("found", getDate(year, month, dayOfMonth, hour, minute));
    return getDate(year, month, dayOfMonth, hour, minute);
};
// function getEarliestDate(date1: Date, date2: Date) {
//     return date1.getTime() <= date2.getTime() ? date1 : date2
// }
function getLatestDate(date1, date2) {
    return date1.getTime() >= date2.getTime() ? date1 : date2;
}
function getDate(year = 0, month = 1, dayOfMonth = 1, hour = 0, minute = 0) {
    try {
        return new Date(Date.UTC(year, month - 1, dayOfMonth, hour, minute));
    }
    catch (e) {
        console.error('get date error');
        console.error(e);
        return new Date(0);
    }
}
function nextCron(parsed, from, duration, options) {
    const { inclusive = false, tz = 'utc' } = options || {};
    // iter is just a safety net to prevent infinite recursive calls
    // because I'm not 100% sure this won't happen
    const findFrom = (from) => {
        return findOnce(parsed, new Date(((from.getTime() - duration + (inclusive ? -60000 : 60000)) / 60000) * 60000));
    };
    let nextOccurence = findFrom(from);
    const adjustAmountMin = nextOccurence ? (0, common_1.adjustDateForDST)(nextOccurence, parsed, tz) : 60;
    if (adjustAmountMin !== 0) {
        const newNextOccurence = findFrom(new Date(from.getTime() - adjustAmountMin * 60000));
        if (newNextOccurence && adjustAmountMin === (0, common_1.adjustDateForDST)(newNextOccurence, parsed, tz)) {
            nextOccurence = newNextOccurence;
        }
    }
    if (nextOccurence === null
        || parsed.end === null
        || nextOccurence.getTime() < parsed.end.getTime())
        return nextOccurence;
    return null;
    // new Date((Math.floor(from.getTime() / 60000) + 1) * 60000)
}
exports.nextCron = nextCron;
function nextRate(rate, from, inclusive = false) {
    if (from == null)
        return null;
    const fromTime = new Date(from).getTime();
    const startTime = rate.start.getTime();
    let time = startTime;
    while (inclusive ? time < fromTime : time <= fromTime) {
        time += rate.rate * 1000;
    }
    if (rate.end && time + rate.duration > rate.end.getTime())
        return null;
    return new Date(time);
}
exports.nextRate = nextRate;
//# sourceMappingURL=next.js.map